export default "__VITE_ASSET__Cuu49AH3__"